export default {"src":"/_next/static/media/checkbox.a226fcee.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};